import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/vorlage'

function* fetchVorlagesRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchVorlages'))
  if (fe == null) {
    fe.size = 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_VORLAGE,
    result,
  })
}

function* fetchVorlages({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchVorlages'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchVorlages', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_VORLAGE,
    result,
  })
}

function* fetchVorlageEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_VORLAGE,
    result,
  })
}

function* fetchVorlageSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_VORLAGE_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_VORLAGES,
  })
}

function* fetchVorlageDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_VORLAGE_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_VORLAGES,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_VORLAGES, fetchVorlages),
    takeEvery(actions.FETCH_VORLAGE, fetchVorlageEdit),
    takeEvery(actions.SAVE_VORLAGE, fetchVorlageSave),
    takeEvery(actions.DELETE_VORLAGE, fetchVorlageDelete),
    takeEvery(actions.RE_FETCH_VORLAGES, fetchVorlagesRefresh),
  ])
}
